import Vue from 'vue'
import Router from 'vue-router'
import ShopIndex from '../page/shop/shop_index'
import ShopGoodsList from '../page/shop/shop_goods_list'
import ShopIntroduction from '../page/shop/shop_introduction'
import ShopCart from '../page/shop/shopCart'
import GoodsDetail from '../page/goods/goodsDetail'
import SampleDetail from '../page/goods/sampleDetail'
import OrderCommit from '../page/order/orderCommit'
import OrderConfirm from '../page/order/orderConfirm'
import OrderPaySuccess from '../page/order/orderPaySuccess'
import Index from '../page/index/index'
import Login from '../page/login/login'
import Address from '../page/address/address'
import AddressList from '../page/address/address_list'
import GoodsList from '../page/goods/goodsList'
import MeterialList from '../page/goods/meterialList'
import SampleList from '../page/goods/sampleList'
import SeckillList from '../page/goods/seckillList'
import GoodsClassList from '../page/goods/goodsClassList'
import ShopsList from '../page/shop/shopsList'
import PaySuccess from '../page/pay/paySuccess'
import PayComplete from '../page/pay/payComplete'
import PointsArea from '../page/points/points_area'
import PayScanQrcode from '../page/order/payScanQrcode'
import ContactSupplier from '../page/goods/contactSupplier'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/shop_index',
      name: 'shop_index',
      component: ShopIndex
    },{
      path: '/shop_goods_list',
      name: 'shop_goods_list',
      component: ShopGoodsList
    },{
      path: '/shopCart',
      name: 'shopcart',
      component: ShopCart
    }, {
      path: '/goodsDetails',
      name: 'goodsdetail',
      component: GoodsDetail
    }, {
      path: '/sampleDetail',
      name: 'sampledetail',
      component: SampleDetail
    }, {
      path: '/orderCommit',
      name: 'ordercommit',
      component: OrderCommit
    }, {
    	path: '/orderConfirm',
      name: 'orderconfirm',
      component: OrderConfirm
    }, {
    	path: '/orderPaySuccess',
      name: 'orderpaysuccess',
      component: OrderPaySuccess
    }, {
    	path: '/',
      name: 'index',
      component: Index
    }, {
    	path: '/login',
      name: 'login',
      component: Login
    }, {
    	path: '/address',
      name: 'address',
      component: Address
    }, {
    	path: '/address_list',
      name: 'address_list',
      component: AddressList
    }, {
    	path: '/goodsList',
      name: 'goodsList',
      component: GoodsList
    }, {
    	path: '/sampleList',
      name: 'sampleList',
      component: SampleList
    }, {
    	path: '/meterialList',
      name: 'meterialList',
      component: MeterialList
    }, {
    	path: '/seckillList',
      name: 'seckillList',
      component: SeckillList
    },{
    	path: '/goodsClassList',
      name: 'goodsClassList',
      component: GoodsClassList
    },{
    	path: '/shopsList',
      name: 'shopsList',
      component: ShopsList
    },{
    	path: '/shopIntroduction',
      name: 'shopIntroduction',
      component: ShopIntroduction
    }, {
    	path: '/paySuccess',
      name: 'paySuccess',
      component: PaySuccess
    }, {
    	path: '/payComplete',
      name: 'payComplete',
      component: PayComplete
    }, {
    	path: '/points_area',
      name: 'points_area',
      component: PointsArea
    }, {
    	path: '/payScanQrcode',
      name: 'payScanQrcode',
      component: PayScanQrcode
    }, {
    	path: '/contactSupplier',
      name: 'contactSupplier',
      component: ContactSupplier
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js